import { filesContentOptions } from "./FileOptions";
import {
  HistoryFileActionDescriptionRecord,
  HistoryFileIconRecord,
} from "Data/interfaces/History/IHistoryFileRecord";
import { HistoryFileActionEnum } from "Data/interfaces/History/IHistoryFileApi";

const contentFileIcon: HistoryFileIconRecord = {
  [HistoryFileActionEnum.StatusChanged]: { icon: 'trocarStatus' },
  [HistoryFileActionEnum.FileDownloaded]: { icon: 'download' },
  [HistoryFileActionEnum.FileDeleted]: { icon: 'excluir' },
  [HistoryFileActionEnum.FileMoved]: { icon: 'mover' },
  [HistoryFileActionEnum.FolderCreated]: { icon: 'adicionarPasta', size: 16 },
  [HistoryFileActionEnum.FolderDeleted]: { icon: 'excluir' },
  [HistoryFileActionEnum.FileRenamed]: { icon: 'input', size: 16 },
  [HistoryFileActionEnum.DescriptionUpdated]: { icon: 'collapse', size: 8 },
  [HistoryFileActionEnum.FileCreated]: { icon: 'upload' },
  [HistoryFileActionEnum.FileVersionAdded]: { icon: 'upload' },
  [HistoryFileActionEnum.FileRendered]: { icon: 'editar', size: 8 },
  // [HistoryFileActionEnum.obsolet]: { icon: 'obsoleteArchive' },
  // [HistoryFileActionEnum.edit]: { icon: 'editar' },
}

const actionFileDescription: HistoryFileActionDescriptionRecord = {
  [HistoryFileActionEnum.StatusChanged]: 'atualizou o arquivo',
  [HistoryFileActionEnum.FileDownloaded]: 'fez download do arquivo',
  [HistoryFileActionEnum.FileDeleted]: "excluiu um arquivo",
  [HistoryFileActionEnum.FileMoved]: "moveu o arquivo",
  [HistoryFileActionEnum.FolderCreated]: "criou uma nova pasta",
  [HistoryFileActionEnum.FolderDeleted]: "excluiu uma pasta",
  [HistoryFileActionEnum.FileRenamed]: "renomeou o arquivo",
  [HistoryFileActionEnum.DescriptionUpdated]: "alterou a descrição do arquivo",
  [HistoryFileActionEnum.FileCreated]: "enviou um arquivo",
  [HistoryFileActionEnum.FileVersionAdded]: "enviou uma nova revisão",
  [HistoryFileActionEnum.FileRendered]: "arquivo renderizado",
}

export { filesContentOptions, contentFileIcon, actionFileDescription };
